import { render, staticRenderFns } from "./TabRejected.vue?vue&type=template&id=09b9b762&scoped=true"
import script from "./TabRejected.vue?vue&type=script&lang=js"
export * from "./TabRejected.vue?vue&type=script&lang=js"
import style0 from "./TabRejected.vue?vue&type=style&index=0&id=09b9b762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9b762",
  null
  
)

export default component.exports